export const invokePciProxy = (key: $TSFixMe, dispatch: $TSFixMe) => (handler: $TSFixMe) =>
    dispatch((_: $TSFixMe, __: $TSFixMe, { pciProxyService }: $TSFixMe) => pciProxyService[key](handler));
